import React from 'react'
import { renderDateTime } from '../../../helpers/HelperMethods';
import { NotificationScenario, PowerAppNotificationScenario } from '../../../GlobalConst/globalEnums';

class MailLogRow extends React.Component
{
    render() {
        const recipientsMessage = this.props.to && <span><b>To:</b> {this.props.to.join(", ")}. {this.props.cc.length > 0 && <span><b>Cc:</b> {this.props.cc.join(", ")}. </span>} </span>

        const mailToRequired = [
            NotificationScenario.siteExpiration,
            NotificationScenario.emptyOwner,
            NotificationScenario.siteCreation,
            NotificationScenario.siteDeletion,
            NotificationScenario.siteDisabled,
            NotificationScenario.ms365ArchivedAnnualReminder,
            NotificationScenario.ms365Archive,
            NotificationScenario.ownerChange,
            NotificationScenario.allChange,
            PowerAppNotificationScenario.recertification,
            PowerAppNotificationScenario.ownerChange,
            PowerAppNotificationScenario.environmentOwnerChange
        ].includes(this.props.scenario);

        return(
            <div style={this.props.even ? highlighted : normal}>
                 <div style={{fontSize: '12px'}} > 
                    <span style={dateStyle}>{renderDateTime(this.props.date)} </span> 
                    <span>{mailToRequired && recipientsMessage}{this.props.status && this.props.scenario && `${this.props.scenario} e-mail with status ${this.props.status}: `}</span>
                    <span>{this.props.subject}</span>
                </div>
            </div>
        );
    }
}
export default MailLogRow

const highlighted = {
    textAlign:'left',
    padding:'8px',
    backgroundColor: 'rgb(205, 230, 247)'
}

const normal = {
    textAlign:'left',
    padding:'8px',
}

const dateStyle = {
    color: 'rgb(120, 120, 120)'
}


// WEBPACK FOOTER //
// ./src/components/Administration/SiteDetails/MailLogRow.js